import React from "react";
import PropTypes from "prop-types";
import constant from "./utils/constant";
import { CircleWithIcon } from "./Common";
import { LinkIcon, AttachIcon, MicIcon } from "../../images";
import clsx from "clsx";

const back_colors = constant.COLOR.BACK_COLOR_OF_CIRCLE_HAS_ICON;
const icons_names = constant.ICON_NAMES;

const ContentHeader = (props) => {
  const iconNames = constant.ICON_NAMES;
  const { activeIcon, showingRestartIcon, onClickFunc } = props;

  const active_link = activeIcon === icons_names.LINK;
  const active_attach = activeIcon === icons_names.ATTACH;
  const active_mic = activeIcon === icons_names.MIC;

  let restart_back_color;
  if (active_mic) restart_back_color = back_colors.ACTIVE_MIC;
  else if (active_attach) restart_back_color = back_colors.ACTIVE_ATTACH;
  else restart_back_color = back_colors.ACTIVE_SMALL_LINK;

  return (
    <>
      {/* // set key for detect difference between elements that has `header`
      classname that cause work animation in every rerender. // when the div
      re-renders, react only changes its inner text. Adding a key will make
      react think it's a different div when the key changes, so it'll unmount it
      and mount again. */}
      <div key='initial-header' className='header initial-header'>
        <div
          className={`tab link-tab${active_link ? " active" : ""}`}
          onClick={() => !active_link && onClickFunc(icons_names.LINK)}
        >
          <span>لینک</span>
          <CircleWithIcon
            ChildComponent={LinkIcon}
            classNames={"icon-wrapper link-icon"}
            style={{ "--svg-color": active_link ? "white" : "#969696" }}
          />
        </div>
        <div
          className={`tab attach-tab${active_attach ? " active" : ""}`}
          onClick={() => !active_attach && onClickFunc(icons_names.ATTACH)}
        >
          <span>بارگذاری فایل</span>
          <CircleWithIcon
            ChildComponent={AttachIcon}
            classNames={"icon-wrapper attach-icon"}
            style={{ "--svg-color": active_attach ? "white" : "#969696" }}
          />
        </div>
        <div
          className={`tab mic-tab${active_mic ? " active" : ""}`}
          onClick={() => !active_mic && onClickFunc(icons_names.MIC)}
        >
          <span>ضبط صدا</span>
          <CircleWithIcon
            ChildComponent={MicIcon}
            classNames={"icon-wrapper mic-icon"}
            style={{ "--svg-color": active_mic ? "white" : "#969696" }}
          />
        </div>
      </div>
      {showingRestartIcon && (
        <div
          style={{ backgroundColor: restart_back_color }}
          onClick={() => onClickFunc(icons_names.RESTART)}
          className={clsx(
            "header restart-header",
            (activeIcon === iconNames.MIC || props.error) &&  "restart-header-show",
          )}
          // set key for detect difference between elements that has `header` classname that cause work animation in every rerender.
          // when the div re-renders, react only changes its inner text. Adding a key will make react think it's a different div when the key changes, so it'll unmount it and mount again.
          key='restart-header'
        >
          <span>شروع دوباره</span>
        </div>
      )}
    </>
  );
};

ContentHeader.propTypes = {
  activeIcon: PropTypes.string.isRequired,
  onClickFunc: PropTypes.func.isRequired,
  showingRestartIcon: PropTypes.bool,
};

// Set default props
ContentHeader.defaultProps = {
  showingRestartIcon: false,
};

export default ContentHeader;
